import { useState, useEffect, useRef } from "react"

import {
  Box,
  Button,
  Container,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material"
import styles from "./ChatGPT.module.css"
import i18n from "i18next"
import useTranslationSharie from "../../hooks/Language/useTranslation"
import T from "../../hooks/Language/T"
import useError from "../../hooks/Error/useError"
import { useApiService } from "../../hooks/Api/useApiService"

function ChatGPT() {
  const [input, setInput] = useState("")
  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const messagesEndRef = useRef(null) // Reference for auto-scroll
  const isHebrew = i18n.language === "he"
  const t = useTranslationSharie()
  const { postData } = useApiService()
  const { Error: ErrorAlert, error, info } = useError()

  const [starter, setStarter] = useState(
    "Hi ,pls reply only this nicely : Here Is Somthing New To Learn Today " +
      localStorage.getItem("user") +
      " then drop a line and start teaching an interesting new skill in 3 to 5 scentences"
  )
  useEffect(() => {
    const savedMessages = JSON.parse(localStorage.getItem("chatHistory") || "[]")
    setMessages(savedMessages)
  }, [])

  // Save the conversation history to localStorage whenever messages change
  useEffect(() => {
    if (messages.length) {
      try {
        localStorage.setItem("chatHistory", JSON.stringify(messages))
      } catch (error) {
        let conversation = localStorage.getItem("chatHistory")
        if (conversation) {
          conversation = JSON.parse(conversation)
          conversation = conversation.slice(-10) // Keep only the last 10 messages
          localStorage.setItem("chatHistory", JSON.stringify(messages))
        }

        info("10 Old messages were deleted")
      }
    }
  }, [messages])

  useEffect(() => {
    const start_conversation = { role: "user", content: starter }
    makeRequest([start_conversation])
    setStarter(null)
  }, [])

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }, [messages])

  async function handleSubmit(e) {
    e.preventDefault()
    const newMessages = [...messages, { role: "user", content: input }]
    setMessages(newMessages)
    setInput("")
    setLoading(true)
    error(null) // Clear any previous error

    makeRequest(newMessages)
  }

  // Refactored makeRequest function to interact with the server
  const makeRequest = async (newMessages) => {
    postData("ai/learnwithai", { messages: newMessages }).then((data) => {
      setMessages((prevMessages) => [
        ...prevMessages,
        { role: "assistant", content: data?.choices[0]?.message?.content },
      ])
    }).catch = (error) => {
      error("Something went wrong. Please try again later.")
    }
    setLoading(false)
  }

  return (
    <T>
      <Container maxWidth='sm' className={styles.ai_container}>
        <Paper elevation={3} className={styles.ai_paper}>
          <Typography variant='h5' align='center' gutterBottom>
            Chat with AI
          </Typography>
          <Box className={styles.ai_inner_box}>
            <List>
              {messages.map((msg, index) => (
                <ListItem
                  key={index}
                  className={msg.role === "user" ? styles.li_primary : styles.li_secondary}
                >
                  <ListItemText
                    primary={msg.role === "user" ? "You" : "AI"}
                    secondary={msg.content}
                  />
                </ListItem>
              ))}
              <div ref={messagesEndRef} />
            </List>
          </Box>
          {error && (
            <Typography color='error' className={styles.error}>
              {error}
            </Typography>
          )}
          <form onSubmit={handleSubmit}>
            <TextField
              variant='outlined'
              fullWidth
              placeholder={t("Type your message...")}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Button
              variant='contained'
              color='primary'
              fullWidth
              type='submit'
              disabled={!input.trim() || loading}
            >
              {loading ? <CircularProgress size={24} /> : "Send"}
            </Button>
          </form>
        </Paper>
        <ErrorAlert />
      </Container>
    </T>
  )
}

export default ChatGPT
